// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
  BooleanField,
  BooleanInput,
} from "react-admin";

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[100, 300, 500]} {...props} />
);

const CDPRVILLAFilter = (props) => (
  <Filter {...props}>
    <TextInput label="id" source="id" alwaysOn />
    <TextInput label="Target" source="target" alwaysOn />
    <TextInput label="Province" source="province" alwaysOn />
    <TextInput label="Region" source="region" alwaysOn />
    <TextInput label="Commune" source="Commune" alwaysOn />
    <BooleanInput label="Display" source="display" />
  </Filter>
);

export const CDPRVILLAList = (props) => (
  <List {...props} filters={<CDPRVILLAFilter />} pagination={<PostPagination />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="target" />
      <TextField source="region" />
      <TextField source="province" />
      <TextField source="commune" />
      <BooleanField source="display" />

      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const CDPRVILLAShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="target" />
      <TextField source="region" />
      <TextField source="province" />
      <TextField source="commune" />
      <BooleanField source="display" />
    </SimpleShowLayout>
  </Show>
);

export const CDPRVILLAEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar alwaysEnableSaveButton />}>
      <TextInput source="id" />
      <TextInput source="target" />
      <TextInput source="region" />
      <TextInput source="province" />
      <TextInput source="commune" />
      <BooleanInput source="display" />
    </SimpleForm>
  </Edit>
);
